export default [
	{
		start: 0.05,
		end: 3,
		text: 'Encore lui ? Quel acharnement...'
	}
]
